function Avatar({externalAvatarIndex}) {
    return (
        <div className="avatar">
            <img
                className="avatar" src={`../../../images/avatar/avatar${externalAvatarIndex}.png`}
                alt="avatar"
                loading={"lazy"}
            />
        </div>
    );
}

export default Avatar;